<template>
  <span class="hk-logo" :class="'hk-logo--' + tone">
    <svg class="hk-logo__mark" :width="size" :height="size" viewBox="0 0 64 64" aria-hidden="true">
      <rect x="41" y="11" width="7" height="13" rx="2" fill="#C26A35" />
      <path d="M9 29 32 10l23 19v22a5 5 0 0 1-5 5H14a5 5 0 0 1-5-5Z" fill="#E0915F" stroke="#E0915F"
        stroke-width="4" stroke-linejoin="round" />
      <path d="M32 47c-9.5-6.3-9-14.5-4-14.5 2.4 0 3.6 1.7 4 3 .4-1.3 1.6-3 4-3 5 0 5.5 8.2-4 14.5Z" fill="#fff" />
    </svg>
    <span v-if="wordmark" class="hk-logo__word" :style="{ fontSize: size * 0.62 + 'px' }">homekind</span>
  </span>
</template>

<script>
export default {
  name: "HomekindLogo",
  props: {
    // "light" for dark backgrounds, "dark" for light backgrounds
    tone: { type: String, default: "light" },
    size: { type: Number, default: 40 },
    wordmark: { type: Boolean, default: true },
  },
};
</script>

<style scoped lang="scss">
.hk-logo {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.hk-logo__mark {
  flex-shrink: 0;
}

.hk-logo__word {
  font-family: $hk-font-heading;
  font-weight: 900;
  letter-spacing: -0.5px;
  line-height: 1;
}

.hk-logo--light .hk-logo__word {
  color: $hk-linen;
}

.hk-logo--dark .hk-logo__word {
  color: $hk-forest;
}
</style>
